export const PERFORM_LOGIN = 'login/performLogin';
export const PERFORM_LOGIN_START = 'login/performLoginStart';
export const PERFORM_LOGIN_COMPLETE = 'login/performLoginCompleted';
export const PERFORM_LOGIN_ERROR = 'login/performLoginError';

export const VERIFY_EMAIL_OTP = 'login/verifyEmailOtp';
export const VERIFY_EMAIL_OTP_START = 'login/verifyEmailOtpStart';
export const VERIFY_EMAIL_OTP_COMPLETE = 'login/verifyEmailOtpCompleted';
export const VERIFY_EMAIL_OTP_ERROR = 'login/verifyEmailOtpError';

export const VERIFY_RESET_PASSWORD_EMAIL = 'login/verifyResetPasswordEmail';
export const VERIFY_RESET_PASSWORD_EMAIL_START = 'login/verifyResetPasswordEmailStart';
export const VERIFY_RESET_PASSWORD_EMAIL_COMPLETE =
  'login/verifyResetPasswordEmailCompleted';
export const VERIFY_RESET_PASSWORD_EMAIL_ERROR = 'login/verifyResetPasswordEmailError';

export const VERIFY_RESET_PASSWORD_OTP = 'login/verifyResetPasswordOtp';
export const VERIFY_RESET_PASSWORD_OTP_START = 'login/verifyResetPasswordOtpStart';
export const VERIFY_RESET_PASSWORD_OTP_COMPLETE = 'login/verifyResetPasswordOtpCompleted';
export const VERIFY_RESET_PASSWORD_OTP_ERROR = 'login/verifyResetPasswordOtpError';

export const CLEAR_LOGIN_ERROR = 'login/clearLoginErrors';
export const CLEAR_FORGOT_PASSWORD_ERROR = 'login/clearForgotPasswordErrors';

export const LOGOUT = 'login/logout';

export const logout = (payload = {}) => ({
  type: LOGOUT,
  payload,
});

export const clearForgotPasswordErrors = (payload = {}) => ({
  type: CLEAR_FORGOT_PASSWORD_ERROR,
  payload,
});

export const clearLoginErrors = (payload = {}) => ({
  type: CLEAR_LOGIN_ERROR,
  payload,
});

export const verifyEmailOtp = (payload = {}) => ({
  type: VERIFY_EMAIL_OTP,
  payload,
});

export const performLogin = (payload = {}) => ({
  type: PERFORM_LOGIN,
  payload,
});

export const verifyResetPasswordEmail = (payload = {}) => ({
  type: VERIFY_RESET_PASSWORD_EMAIL,
  payload,
});

export const verifyResetPasswordOtp = (payload = {}) => ({
  type: VERIFY_RESET_PASSWORD_OTP,
  payload,
});
